import { AccessLevel, DynamicPathAccess } from "./types";

export const findDynamicPathAccess = <T extends AccessLevel>(
  path: Location["pathname"],
  dynamicPathPermissions: DynamicPathAccess[],
  accessLevel: T
) => {
  const findPath = (dynamicPath: DynamicPathAccess) =>
    dynamicPath.pathRegex.test(path);

  const dynamicPath = dynamicPathPermissions.find(findPath);

  return dynamicPath?.[accessLevel];
};
